import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import moment from 'moment';
import isNumber from 'lodash/isNumber';
import some from 'lodash/some';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';
import checkIsExcludedCountryCode from '../../../shared/checkIsExcludedCountryCode';
import { getUniqPayoutCurrencies, getPayoutHeaders, getPayoutCells } from '../../shared';
import {
	isAccessGranted,
	isWaitingForActivation,
	isAccessRejected,
	wasBoostedLocation } from '../../shared';

import createConfirm from '../../../shared/confirm';

lessRequire('modules/offers/components/table/geo-goals.less');

const isRocket = process.env.CPA_ENV === 'rocket';

class GeoGoalsTable extends React.Component {
	constructor(props) {
		super(props);
		const initialState = {
			trHover: false,
			currentIndex: null
		};
		this.state = { ...initialState };
	}
	tdOnMouseEnter(index) {
		//show or hide boost hover
		// this.setState({currentIndex: index});
		// this.setState({trHover: true});
	}
	tdOnMouseLeave() {
		//show or hide boost hover
		// this.setState({currentIndex: null});
		// this.setState({trHover: false});
	}
	render() {
		const { data, intl, boost, offer, user, toggleRules } = this.props;
		const payoutCurrencies = getUniqPayoutCurrencies(data);
		const shouldShowBoosterTH = some(data, item => {
			return item.boost_till == null &&
				!wasBoostedLocation(user.boost_info, offer.id, item.locationId) &&
				!item.is_individual_term &&
				!isWaitingForActivation(offer) &&
				!isAccessRejected(offer) &&
				!user.is_master &&
				item.isBoosterAvailable;
		});

		return (
			<table className="geo-goals-table dashboard-table">
				<thead>
					<tr className="geo-row">
						<th><span>{intl('Страна')}</span></th>
						{!isRocket &&
						<th className="right call-center-timing">
							<span>
								{intl('Время работы колл-центра:')}
							</span>
						</th>
						}
						<th width={1} className="booster-th">{shouldShowBoosterTH ? 'Boost' : ''}</th>

						{getPayoutHeaders(payoutCurrencies, intl, 'left')}
						<th className="right on-site"><span>{intl('На сайте')}</span></th>
						{isRocket && <th className="right"><span>QUID</span></th>}
					</tr>
				</thead>

				<tbody className="dashboard-table__body">
					{data &&
				data.filter(i => !checkIsExcludedCountryCode(i.locationCountryCode)).map((item, i) => (
					<tr className={cn({
						'geo-row': true,
						'boost-hover': this.state.trHover && this.state.currentIndex == i,
						'point__background': item.isContestEnabled && item.contestPoints &&
							parseFloat(item.contestPoints) > 0
					})}
					key={i}
					>
						<td className="country rewrite-shared-style">
							<span className="country-wrapper">
								<span className={`flag-icon flag-icon-${item.locationCountryCode.toLowerCase()}`} />
								<span className="country-title">{item.locationTitle}</span>
							</span>
							{item.locationCountryCode === 'ID' && <span className="id-image-tiger"></span>}
						</td>
						{!isRocket &&
						<td className="call-center-timing">
							{
								item.isOwnCallcenter
								&& <span> { getCallCenterTiming(item) } </span>
							}
						</td>
						}
						{item.boost_till == null &&
						!wasBoostedLocation(user.boost_info, offer.id, item.locationId) &&
						!item.is_individual_term &&
						!isWaitingForActivation(offer) &&
						!isAccessRejected(offer) &&
						!user.is_master &&
						item.isBoosterAvailable ?
							<td onMouseEnter={e => this.tdOnMouseEnter(i)}
								onMouseLeave={this.tdOnMouseLeave.bind(this)}
								className="booster" onClick={e => {
									e.preventDefault();
									this.setState({trHover: false});
									if (isAccessGranted(offer)) {
										createConfirm({
											title: intl('Активировать boost%s', '?'),
											body: intl(
												'Вы подтверждаете включение опции Boost для оффера %s по гео %s',
												`<strong>${offer.title}</strong>`,
												`<strong>${item.locationTitle}</strong>`
											),
											buttonSuccessText: intl('Подтвердить'),
											buttonCancelText: intl('Отмена')
										}).then(isConfirmed => {
											isConfirmed && boost(offer.id, item.locationId);
										});
									} else {
										toggleRules(offer.id, item.locationId);
									}
								}}>
								<span className="booster-btn" />
								<span className="booster-value">+{Math.round(item.boost_value * 10000) / 100}%</span>
							</td> :
							<td />}
						{getPayoutCells(
							item.payouts,
							payoutCurrencies,
							intl,
							'payout rewrite-shared-style',
							item.boost_till,
							item.boost_value
						)}
						<td className="price on-site rewrite-shared-style">
							{isNumber(item.price)
								? <span className="money">
									{item.price} <span className="currency">{getCurrencyIcon(item.priceCurrency)}</span>
								</span>
								: '-'}
						</td>
						{
							isRocket &&
							<td
								className={cn({
									'price': true,
									'quid-price': true,
									'quid-empty': !(
										item.isContestEnabled &&
										item.contestPoints &&
										parseFloat(item.contestPoints) > 0),
									'rewrite-shared-style': true
								})}
								onClick={
									e => {
										e.preventDefault();
										item.isContestEnabled &&
										item.contestPoints &&
										parseFloat(item.contestPoints) > 0 &&
										browserHistory.push('market');
									}}
							>
								{item.isContestEnabled && item.contestPoints && parseFloat(item.contestPoints) > 0
									? <span className="money quid_rate">
										{item.contestPoints}
									</span>
									:'-'}
							</td>
						}
					</tr>
				))}
				</tbody>
			</table>
		);
	}
}

GeoGoalsTable.propTypes = {
	data: PropTypes.array,
	shedullesCallCenter: PropTypes.array,
	offer: PropTypes.object,
	single_offer_id: PropTypes.string,
	user: PropTypes.object,
	intl: PropTypes.func,
	setUnClickableLink: PropTypes.func,
	boost: PropTypes.func,
	toggleRules: PropTypes.func
};

const getCallCenterTiming = ({ locationCountryCode }) => {
	const ccTiming = window.globalConfig.callCenterShedulle[locationCountryCode];
	const utcOffset = !!ccTiming && moment().utc().startOf('day').tz(ccTiming.timezone).utcOffset()/60;

	switch (true) {
		case !ccTiming: return null;
		case ccTiming.start === ccTiming.end: return '24/7';
		default:
			return `${ccTiming.start} - ${ccTiming.end} (GMT +${utcOffset})`;
	}
};

export default connect(
	state => {
		let shedullesCallCenter = state.app &&
			state.app.lists['call-center-schedule'];
		return {
			shedullesCallCenter: shedullesCallCenter.map(i => i.id)
		};
	})(GeoGoalsTable);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/table/geo-goals.js